import styled from 'styled-components';

import Button from '_components/_core/Button';
import Modal from '_components/_core/Modal';

export const StyledModal = styled(Modal)`

`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SearchButton = styled(Button)`
  margin-top: 26px;
  margin-left: 15px;
`;

export const StyledHr = styled.hr`
  margin-bottom: 2rem;
`;

export const SeparatorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  hr {
    height: 1px;
    border-top: 1px;
  }
`;
